import React from "react";
import PropTypes from "prop-types";
import {
  formatPrescriptionReviewedDate,
  getReviewOutcomeDisplay,
  hasPrescriptionReviewSummary,
  resolveReviewedByLabel,
} from "@/services/prescriptionReview";
import {
  fieldLabel,
  fieldValue,
  pafSectionLabelClass,
} from "../constants/viewPafConstants";

const outcomeBoxClass =
  "mt-2 rounded-lg border border-gray-300 bg-gray-50 px-4 py-3 text-sm leading-relaxed text-[#3c3c3c]";

function PrescriptionReviewSummary({ prescription }) {
  if (!hasPrescriptionReviewSummary(prescription)) return null;

  const reviewedBy = resolveReviewedByLabel(prescription);
  const reviewedDate = formatPrescriptionReviewedDate(
    (prescription?.prescription ?? prescription)?.reviewed_date
  );
  const outcome = getReviewOutcomeDisplay(prescription);

  return (
    <div
      className="mt-6 border-t border-[#dcdcdc] pt-5"
      data-testid="paf-review-summary"
    >
      <div className="mb-4 flex" data-testid="paf-review-summary-reviewed-by">
        <div>
          <div className={fieldLabel}>Reviewed By:</div>
          <div className={fieldValue} data-testid="paf-review-summary-reviewer">
            {reviewedBy}
          </div>
          <div className={fieldValue} data-testid="paf-review-summary-date">
            {[reviewedDate].filter((part) => part && part !== "—").join(" ")}
          </div>
        </div>
      </div>

      {outcome?.detail && (
        <div data-testid="paf-review-summary-outcome">
          <div className={pafSectionLabelClass}>Review Outcome</div>
          <div className={outcomeBoxClass} data-testid="paf-review-summary-outcome-detail">
            {outcome.isOther ? (
              <>
                <span className="font-semibold">{outcome.label}:</span>{" "}
                {outcome.detail}
              </>
            ) : (
              outcome.detail
            )}
          </div>
        </div>
      )}
    </div>
  );
}

PrescriptionReviewSummary.propTypes = {
  prescription: PropTypes.object,
};

export default PrescriptionReviewSummary;
